import { render, staticRenderFns } from "./AnalyticsOpportunityBusiness.vue?vue&type=template&id=cf284be8"
import script from "./AnalyticsOpportunityBusiness.vue?vue&type=script&lang=js"
export * from "./AnalyticsOpportunityBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports